/**
 * No-op shim that replaces `@splitbee/web`.
 *
 * Splitbee.io has been shut down (cdn.splitbee.io/sb.js returns HTTP 410), so
 * importing the real package only injects a dead third-party script and
 * triggers a Best Practices failure on Lighthouse. Nothing on the site relies
 * on Splitbee analytics anymore, so we replace it with a tiny stub that
 * preserves every call-site signature without performing any work.
 */

type SplitbeeUserData = Record<string, unknown>;

const splitbee = {
  init(_options?: Record<string, unknown>): void {},
  track(_name: string, _props?: Record<string, unknown>): void {},
  user: {
    set(_data: SplitbeeUserData): void {},
  },
  reset(): void {},
};

export default splitbee;
